import React, { useEffect, useMemo, useState } from "react";
import { getSelectedPatientProfile } from "../actions/epicActions";
import { ageForDob, getFormattedDate } from "../../../helper/CommonFuncs";
import LoaderShade from "../../../shared/components/loaderShade/loaderShade";

const EpicHeader = ({ patientDetails }) => {
   const fullName = patientDetails?.name?.fullName;
   const dob = useMemo(() => {
      return patientDetails?.dob ? ageForDob(patientDetails?.dob) : "-";
   }, [patientDetails]);

   const dobFormatted = useMemo(() => {
      return patientDetails?.dob ? getFormattedDate(patientDetails?.dob) : "--/--/----";
   }, [patientDetails]);

   return (
      <div className="epic-header-text epic-header-container ">
         {patientDetails === null ? (
            <LoaderShade classname="epic-loaders" />
         ) : (
            <div className="patient-name-epic">{fullName}</div>
         )}
         <div className=" mt-2 patient-details-container">
            {patientDetails === null ? <LoaderShade classname="epic-date-loaders" /> : <div>DOB: {dobFormatted}</div>}
            <div className="analytics-line-v2" />
            {patientDetails === null ? <LoaderShade classname="epic-age-loaders" /> : <div>Age: {dob} &nbsp;</div>}
         </div>
      </div>
   );
};

export default EpicHeader;
